import { Lightning } from '@lightningjs/sdk';
import { RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { templates, sizes } from '../jumbotron.constants';
import { LAYOUT_BOTTOM_MARGIN } from '../jumbotron.style';
import { getInitialStyle } from './jumbotron.skeleton.style';

/**
 * A loading placeholder of the Jumbotron, mirroring its layout with animated rectangles
 *
 * @see ../jumbotron.component.js
 */
export class JumbotronSkeleton extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  // NOTE: the bottom margin repeats Jumbotron.getBottomMargin, which the Solo block applies as a block offset
  static getHeight({ screenSize }) {
    return sizes[templates.Jumbotron][RENDERING_CONTEXT.GENERAL][screenSize].h + LAYOUT_BOTTOM_MARGIN[screenSize];
  }

  set contentPadding(value) {
    this.patch({
      FlexContainer: {
        x: Number.isFinite(value) ? value : 0,
      },
    });
  }
}
